@if (pageReady) {
  <main class="gs-page multi-account">
    <div class="gs-page-inner">
      <app-page-header [headerData]="pageHeader"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <form [formGroup]="searchForm" class="search-container">
          <mat-form-field class="gs-form-field search" appearance="outline">
            <mat-label id="searchLabel">Search Account Number</mat-label>
            <input matInput id="search" formControlName="Search" />
            <button
              matSuffix
              mat-button
              color="primary"
              (click)="searchAccount()"
              aria-label="Search for account number"
            >
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
            <button matSuffix mat-button color="primary" (click)="clearSearch()" aria-label="Clear search results">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </mat-form-field>
        </form>
        @if (!isMobile) {
          <mat-card class="header-card">
            <h2 class="table-header name-header">{{ pageLabels.accountNameTableHeader }}</h2>
            <h2 class="table-header address-header">{{ pageLabels.addressTableHeader }}</h2>
            <h2 class="table-header account-header">{{ pageLabels.accountNumberTableHeader }}</h2>
            <h2 class="table-header balance-header">{{ pageLabels.balanceTableHeader }}</h2>
            <h2 class="table-header payment-header">{{ pageLabels.paymentTableHeader }}</h2>
            <h2 class="table-header date-header">{{ pageLabels.dueDateTableHeader }}</h2>
            <h2 class="table-header manage-header">{{ pageLabels.manageTableHeader }}</h2>
            <h2 class="table-header activity-header">{{ pageLabels.activityTableHeader }}</h2>
          </mat-card>
        }
        @if (multiState.Accounts.length >= 1) {
          @for (account of multiState.Accounts; track account) {
            @if (!isMobile) {
              <mat-card class="account-card">
                @if (account.Nickname.displayText) {
                  <p class="table-data nickname-link" [matTooltip]="account.Nickname.displayText">
                    {{ account.Nickname.displayText?.substring(0, 12) }}
                  </p>
                } @else {
                  <p class="table-data nickname-link"></p>
                }

                <p class="table-data address" [matTooltip]="account.Address">
                  {{ account.Address.substring(0, 15) }}
                </p>

                <a
                  class="table-data account-number"
                  [routerLink]="account.AccountNumber.url.url"
                  [attr.ariaLabel]="account.AccountNumber.ariaLabel"
                  [state]="{ accountNumber: account.AccountNumber.displayText }"
                >
                  {{ account.AccountNumber.displayText }}
                </a>

                <p class="table-data balance">{{ account.Balance }}</p>

                @if (account.PayNow) {
                  <a
                    class="table-data pay-link"
                    [routerLink]="account.PayNow.url.url"
                    [attr.aria-label]="account.PayNow.ariaLabel"
                    [state]="{ accountNumber: account.AccountNumber.displayText }"
                  >
                    {{ account.PayNow.displayText }}
                  </a>
                } @else {
                  <div class="table-data pay-link"></div>
                }

                <p class="table-data due-date">{{ account.DueDate }}</p>

                <a
                  class="table-data manage-link"
                  [routerLink]="account.Manage.url.url"
                  [attr.aria-label]="account.Manage.ariaLabel"
                  [state]="{ accountNumber: account.AccountNumber.displayText }"
                >
                  {{ account.Manage.displayText }}
                </a>

                @if (account.Activity) {
                  <a
                    class="table-data activity-link"
                    [routerLink]="account.Activity.url.url"
                    [attr.aria-label]="account.Activity.ariaLabel"
                    [state]="{ accountNumber: account.AccountNumber.displayText }"
                  >
                    {{ account.Activity.displayText }}
                  </a>
                } @else {
                  <div class="table-data activity-link"></div>
                }
              </mat-card>
            } @else {
              <mat-expansion-panel class="account-card">
                <mat-expansion-panel-header>
                  <div class="top-data">
                    @if (account.Nickname.displayText) {
                      <p class="table-data nickname-link">{{ account.Nickname.displayText }}</p>
                    }

                    <p class="table-data address" [matTooltip]="account.Address">
                      {{ account.Address }}
                    </p>

                    <a
                      class="table-data account-number"
                      [routerLink]="account.AccountNumber.url.url"
                      [attr.ariaLabel]="account.AccountNumber.ariaLabel"
                      [state]="{ accountNumber: account.AccountNumber.displayText }"
                    >
                      {{ account.AccountNumber.displayText }}
                    </a>

                    <p class="table-data balance">{{ account.Balance }}</p>
                  </div>
                </mat-expansion-panel-header>
                <div class="bottom-data">
                  @if (account.PayNow) {
                    <a
                      class="table-data pay-link"
                      [routerLink]="account.PayNow.url.url"
                      [attr.aria-label]="account.PayNow.ariaLabel"
                      [state]="{ accountNumber: account.AccountNumber.displayText }"
                    >
                      {{ account.PayNow.displayText }}
                    </a>
                  } @else {
                    <div class="table-data pay-link"></div>
                  }

                  <p class="table-data due-date">{{ account.DueDate }}</p>

                  <a
                    class="table-data manage-link"
                    [routerLink]="account.Manage.url.url"
                    [attr.aria-label]="account.Manage.ariaLabel"
                    [state]="{ accountNumber: account.AccountNumber.displayText }"
                  >
                    {{ account.Manage.displayText }}
                  </a>

                  @if (account.Activity) {
                    <a
                      class="table-data activity-link"
                      [routerLink]="account.Activity.url.url"
                      [attr.aria-label]="account.Activity.ariaLabel"
                      [state]="{ accountNumber: account.AccountNumber.displayText }"
                    >
                      {{ account.Activity.displayText }}
                    </a>
                  } @else {
                    <div class="table-data activity-link"></div>
                  }
                </div>
              </mat-expansion-panel>
            }
          }
          @if (multiAccount.TotalNumAccounts > pageLabels.pageSize) {
            <mat-paginator
              [length]="multiAccount.TotalNumAccounts"
              [pageSize]="pageLabels.pageSize"
              aria-label="Select page"
              showFirstLastButtons="true"
              (page)="pageChanged($event)"
              [pageIndex]="multiState.Page - 1"
            >
            </mat-paginator>
          }
        } @else {
          <p role="alert">No matching account found</p>
        }
      </div>
    </div>
  </main>
}
